// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Sora:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after{
  box-sizing:border-box;
}

html,
body{
  margin:0;
  padding:0;
  background:var(--bg-page);
}

body{
  color:var(--text-main);
  font-family:"Sora",system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;
  font-style:normal;
  -webkit-font-smoothing:antialiased;
  text-rendering:optimizeLegibility;
}

code,
pre,
kbd,
samp{
  font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,"Liberation Mono","Courier New",monospace;
}

img{
  display:block;
  max-width:100%;
}

a{
  color:inherit;
  text-decoration:none;
}

button{
  font:inherit;
}

/* =============================================================================
   BODHIWELL TYPOGRAPHY SYSTEM (Tokens V2)
   ============================================================================= */



/* 2. Estilos para Títulos (Headings) */

h1, .h1 {
    font-size: 64px;
    line-height: 1.0;
    font-weight: 700;
    letter-spacing: -0.045em;
    color: var(--bw-text);
    margin: 0;
}

h2, .h2 {
    font-size: 48px;
    line-height: 1.04;
    font-weight: 800;
    letter-spacing: -0.035em;
    color: var(--bw-text);
    margin: 0;
}

h3, .h3 {
    font-size: 24px;
    line-height: 1.28;
    font-weight: 600;
    letter-spacing: -0.015em;
    color: var(--bw-text);
    margin: 0;
}

/* 3. Estilos para Textos de Cuerpo y Soporte */

body, .body, p {
    font-size: 16px;
    line-height: 1.65;
    font-weight: 400;
    color: var(--bw-text);
}

.small, small {
    font-size: 14px;
    line-height: 1.5;
    font-weight: 400;
    color: var(--bw-text-secondary); 
}

.caption {
    font-size: 13px;
    line-height: 1.35;
    font-weight: 400;
    color: var(--bw-text-tertiary);   
}

/* 4. Clases Utilitarias Adicionales (Labels y Eyebrows) */

/* Usado para secciones pequeñas en mayúsculas como "VOCACIÓN" */
.eyebrow {
    font-size: 12px;
    line-height: 1.2;
    font-weight: 800;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: var(--bw-primary); 
}

/* Labels de campos o etiquetas técnicas */
.label {
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: var(--bw-text-secondary);
    margin-bottom: 10px;
}

/* Estilo Monospace para datos técnicos o IDs */
.mono {
    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace !important;
    font-size: 14px;
    color: #5D6D66;
}

.preview-container, .header-inner, .footer-wrap {
    width: min(100%, var(--base-container));
    margin: 0 auto;
}

/* 5. Ajustes de Responsividad Básica */
@media (max-width: 980px) {
    h1, .h1 { font-size: 48px; }
    h2, .h2 { font-size: 36px; }
    .title { font-size: 40px; }
}

`, "",{"version":3,"sources":["webpack://./src/assets/styles/styles.css"],"names":[],"mappings":"AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;;EAEE,QAAQ;EACR,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,mFAAmF;EACnF,iBAAiB;EACjB,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;;;;EAIE,uGAAuG;AACzG;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;;kFAEkF;;;;AAIlF,uCAAuC;;AAEvC;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,qBAAqB;IACrB,SAAS;AACb;;AAEA,+CAA+C;;AAE/C;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA,0DAA0D;;AAE1D,gEAAgE;AAChE;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA,0CAA0C;AAC1C;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA,+CAA+C;AAC/C;IACI,gFAAgF;IAChF,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,uCAAuC;IACvC,cAAc;AAClB;;AAEA,uCAAuC;AACvC;IACI,UAAU,eAAe,EAAE;IAC3B,UAAU,eAAe,EAAE;IAC3B,SAAS,eAAe,EAAE;AAC9B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Sora:ital,wght@0,100..800;1,100..800&display=swap');\n\n*,\n*::before,\n*::after{\n  box-sizing:border-box;\n}\n\nhtml,\nbody{\n  margin:0;\n  padding:0;\n  background:var(--bg-page);\n}\n\nbody{\n  color:var(--text-main);\n  font-family:\"Sora\",system-ui,-apple-system,BlinkMacSystemFont,\"Segoe UI\",sans-serif;\n  font-style:normal;\n  -webkit-font-smoothing:antialiased;\n  text-rendering:optimizeLegibility;\n}\n\ncode,\npre,\nkbd,\nsamp{\n  font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace;\n}\n\nimg{\n  display:block;\n  max-width:100%;\n}\n\na{\n  color:inherit;\n  text-decoration:none;\n}\n\nbutton{\n  font:inherit;\n}\n\n/* =============================================================================\n   BODHIWELL TYPOGRAPHY SYSTEM (Tokens V2)\n   ============================================================================= */\n\n\n\n/* 2. Estilos para Títulos (Headings) */\n\nh1, .h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n    color: var(--bw-text);\n    margin: 0;\n}\n\nh2, .h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n    color: var(--bw-text);\n    margin: 0;\n}\n\nh3, .h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n    color: var(--bw-text);\n    margin: 0;\n}\n\n/* 3. Estilos para Textos de Cuerpo y Soporte */\n\nbody, .body, p {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n    color: var(--bw-text);\n}\n\n.small, small {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n    color: var(--bw-text-secondary); \n}\n\n.caption {\n    font-size: 13px;\n    line-height: 1.35;\n    font-weight: 400;\n    color: var(--bw-text-tertiary);   \n}\n\n/* 4. Clases Utilitarias Adicionales (Labels y Eyebrows) */\n\n/* Usado para secciones pequeñas en mayúsculas como \"VOCACIÓN\" */\n.eyebrow {\n    font-size: 12px;\n    line-height: 1.2;\n    font-weight: 800;\n    letter-spacing: 0.16em;\n    text-transform: uppercase;\n    color: var(--bw-primary); \n}\n\n/* Labels de campos o etiquetas técnicas */\n.label {\n    font-size: 12px;\n    font-weight: 800;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    color: var(--bw-text-secondary);\n    margin-bottom: 10px;\n}\n\n/* Estilo Monospace para datos técnicos o IDs */\n.mono {\n    font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace !important;\n    font-size: 14px;\n    color: #5D6D66;\n}\n\n.preview-container, .header-inner, .footer-wrap {\n    width: min(100%, var(--base-container));\n    margin: 0 auto;\n}\n\n/* 5. Ajustes de Responsividad Básica */\n@media (max-width: 980px) {\n    h1, .h1 { font-size: 48px; }\n    h2, .h2 { font-size: 36px; }\n    .title { font-size: 40px; }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
